"use client";

import { useState } from "react";
import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FreeConsultation() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    message: ""
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
  };
  return <section ref={sectionRef} className="relative py-24 px-4 overflow-hidden bg-gradient-to-br from-accent-light via-background to-accent-light/30">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-4">
            無料相談
          </h2>
          <div className="relative h-0.5 w-32 mx-auto mb-6">
            <div className={`absolute inset-0 bg-primary transition-all duration-[600ms] ease-[var(--ease-out-back)] ${isVisible ? "scale-x-100" : "scale-x-0"}`} style={{
            transformOrigin: "center"
          }} />
          </div>
          <p className="text-foreground-muted text-lg max-w-2xl mx-auto">
            ベトナム市場進出に関するご質問やご相談がございましたら、お気軽にお問い合わせください。
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`} style={{
          transitionDelay: "100ms"
        }}>
            <label htmlFor="name" className="block text-sm font-semibold text-foreground mb-2">
              お名前 <span className="text-accent">*</span>
            </label>
            <Input id="name" name="name" type="text" value={formData.name} onChange={handleChange} required placeholder="山田 太郎" className="w-full bg-background border-border-strong shadow-soft rounded-md focus-visible:border-primary focus-visible:ring-accent/30" />
          </div>

          <div className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`} style={{
          transitionDelay: "200ms"
        }}>
            <label htmlFor="email" className="block text-sm font-semibold text-foreground mb-2">
              メールアドレス <span className="text-accent">*</span>
            </label>
            <Input id="email" name="email" type="email" value={formData.email} onChange={handleChange} required placeholder="example@company.co.jp" className="w-full bg-background border-border-strong shadow-soft rounded-md focus-visible:border-primary focus-visible:ring-accent/30" />
          </div>

          <div className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`} style={{
          transitionDelay: "300ms"
        }}>
            <label htmlFor="company" className="block text-sm font-semibold text-foreground mb-2">
              会社名
            </label>
            <Input id="company" name="company" type="text" value={formData.company} onChange={handleChange} placeholder="株式会社〇〇" className="w-full bg-background border-border-strong shadow-soft rounded-md focus-visible:border-primary focus-visible:ring-accent/30" />
          </div>

          <div className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`} style={{
          transitionDelay: "400ms"
        }}>
            <label htmlFor="message" className="block text-sm font-semibold text-foreground mb-2">
              お問い合わせ内容 <span className="text-accent">*</span>
            </label>
            <Input id="message" name="message" type="text" value={formData.message} onChange={handleChange} required placeholder="ご相談内容をご記入ください" className="w-full bg-background border-border-strong shadow-soft rounded-md focus-visible:border-primary focus-visible:ring-accent/30 h-32" />
          </div>

          <div className={`flex justify-center pt-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: "500ms"
        }}>
            <Button type="submit" size="lg" className="btn-primary shadow-medium group relative overflow-hidden">
              <span className="relative z-10 flex items-center gap-2">
                送信する
                <Send className="size-4 transition-transform duration-[var(--duration-medium)] group-hover:translate-x-1" />
              </span>
              <span className="absolute inset-0 bg-accent/20 rounded-md scale-0 group-hover:scale-100 transition-transform duration-[var(--duration-slow)] ease-[var(--ease-spring)] animate-pulse" />
            </Button>
          </div>
        </form>
      </div>
    </section>;
}